
/**
 * @description 存储localstorage
 * @param {存储的keyName} name
 * @param {存储的值} value
 */
const setStore = (name, value) => {
    if (!name) return;
    if (typeof value !== 'string') {
        value = JSON.stringify(value)
    }
    window.sessionStorage.setItem(name, value)
}

/**
 * @description 读取localstorage
 * @param {存储的keyName} name
 */
const getStore = (name) => {
    if (!name) return;
    let str = window.sessionStorage.getItem(name);
    if(isJsonString(str)){
        return JSON.parse(str);
    }else{
        return str;
    };
}

/**
 * @description 删除localstorage
 * @param {需要删除的keyName} name
 */
const removeStroe = (name) => {
    if (!name) return;
    window.sessionStorage.removeItem(name)
}
function isJsonString(str){
    if(typeof str == 'string'){
        try {
            JSON.parse(str);
            return true;
        } catch (error) {
            return false;
        };
    };
}
export default {
    setStore:setStore,
    getStore:getStore,
    removeStroe:removeStroe,
};



// WEBPACK FOOTER //
// ./src/utils/sessionStorage.js